// The logo mark + wordmark as a link home.
//
// /demo hides the global Navbar so the canvas gets a single header bar instead
// of two stacked ones, which makes this the only way back to the marketing
// site from that route — it has to be present on both the demo shell and the
// mounted canvas. Markup matches Navbar's brand block deliberately, so the
// header swap is invisible when navigating between routes.
export function BrandLink({ className = "" }: { className?: string }) {
  return (
    <a
      href="/"
      className={`flex shrink-0 items-center gap-2.5 ${className}`}
      aria-label="OmniCanvas home"
    >
      <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-600">
        <span className="text-sm font-bold text-white">O</span>
      </div>
      <span className="hidden text-lg font-bold tracking-tight sm:inline">
        OmniCanvas
      </span>
    </a>
  );
}
